import type { FunctionComponent } from "react";

import type { Dayjs } from "dayjs";
import ReactDOMServer from "react-dom/server";

import type { IconName } from "@similarweb/icons";

import {
    Marker,
    MarkerIcon,
    MarkerTooltip,
    TooltipEdge,
    MarkerTooltipDescription,
    MarkerTooltipTitle,
    LinkItem,
    AlertIcon,
} from "pro-features/components/Chart/src/configs/tooltip/graphBellTooltip/graphBellTooltipStyledComponents";
import { translate } from "app/filters/i18nFilter";

export interface ITooltipsGraphConfig {
    description: string;
    date?: Dayjs;
    value?: Dayjs | number;
    backgroundColor?: string;
    icon?: IconName;
    isTooltipLineDisabled?: boolean;
    link?: ITooltipsGraphLink;
    isTooltipDisabled?: boolean;
}

interface ITooltipsGraphLink {
    text: string;
    link: string;
}

const iconName = "alerts";

const TooltipLink: FunctionComponent<ITooltipsGraphLink> = ({ text, link }) => (
    <LinkItem
        href={link}
        target="_blank"
    >
        {translate(text)}
    </LinkItem>
);

/*
@deprecated
import { notificationTooltipContainerConfig } from "@similarweb/pro-logic-components"
*/
export default (tooltipsGraphConfigs: ITooltipsGraphConfig[]): Highcharts.Options => {
    return {
        xAxis: {
            plotLines: tooltipsGraphConfigs.map((config) => {
                return {
                    color: "#7F8B97",
                    width: config.isTooltipLineDisabled ? 0 : 1,
                    dashStyle: "Dash",
                    value: (config.date || config.value) as number,
                    label: {
                        text: ReactDOMServer.renderToString(
                            <Marker color={config.backgroundColor}>
                                {config.icon ? (
                                    <AlertIcon
                                        size="sm"
                                        iconName={config.icon}
                                    />
                                ) : (
                                    <MarkerIcon iconName={iconName} />
                                )}

                                {config.isTooltipDisabled ? null : (
                                    <MarkerTooltip>
                                        {
                                            <MarkerTooltipTitle>
                                                {config.date?.format("dddd, MMM DD, YYYY")}
                                            </MarkerTooltipTitle>
                                        }
                                        <MarkerTooltipDescription>
                                            {translate(config.description)}
                                            {config.link ? (
                                                <TooltipLink
                                                    link={config.link.link}
                                                    text={config.link.text}
                                                />
                                            ) : null}
                                        </MarkerTooltipDescription>
                                        <TooltipEdge />
                                    </MarkerTooltip>
                                )}
                            </Marker>,
                        ),
                        useHTML: true,
                        x: -10,
                        y: 0,
                        rotation: 0,
                        verticalAlign: "bottom",
                    },
                };
            }),
        },
    };
};
